import { reactive } from 'vue'
import { useRouter } from 'vue-router'

interface State {
  cartOpened: boolean
}

const state = reactive<State>({
  cartOpened: false,
})

function reset() {
  state.cartOpened = false
}

function create() {
  const router = useRouter()

  router.beforeEach(() => {
    reset()
  })

  return state
}

let cache: ReturnType<typeof create>

export function useAppSidePanelState() {
  if (!cache) {
    cache = create()
  }
  return cache
}
